// @ts-nocheck
/* eslint-enable */
import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { padding } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';
import { inset, stacked } from 'app/shared/styles/_spacing';

// Components
import LinkerBase from 'app/shared/modules/Linker';

export const Footer = styled.footer`
  ${font.sm};
  ${padding.top._3x};
  ${padding.right._2x};
  ${padding.bottom._3x};
  ${padding.left._2x};
  background-color: ${colors['$hpx-blue-600']};
  color: ${colors['$hpx-white']};
`;

export const FooterList = styled.ul`
  display: flex;
  list-style: none;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Li = styled.li`
  ${inset._1x};
  font-weight: bold;
`;

export const Linker = styled(LinkerBase)`
  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 5px;
  }
`;

export const AppBadgeSection = styled.section`
  display: flex;
  justify-content: center;
  ${stacked._1x};
`;

export const BadgeImg = styled.img`
  margin: 8px;
`;

export const Paragraph = styled.p`
  ${font.tiny};
  text-align: center;
  ${stacked._2x};
`;

export const HudImg = styled.img`
  ${padding.left._xs};
`;
